import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <circle cx={12} cy={12} r={9.4} stroke="currentColor" strokeWidth={1.2} />
    <path
      fill="currentColor"
      d="M12.229 8a.79.79 0 0 1 .613.26.88.88 0 0 1 .236.63q0 .406-.271.689a.86.86 0 0 1-.649.27.86.86 0 0 1-.637-.248.86.86 0 0 1-.236-.62q0-.394.284-.688.294-.293.66-.293m-.413 2.841q.59 0 .838.339.259.337.259.97 0 .338-.094 1.025-.095.676-.118.869-.024.146-.095.654-.07.496-.07.688 0 .293.177.293.318 0 .577-.891l.637.18q-.071.373-.306.778-.236.406-.614.7a1.42 1.42 0 0 1-.872.281q-.626 0-.885-.315-.248-.315-.248-.959 0-.507.213-1.793.177-1.105.177-1.477 0-.293-.19-.293-.305 0-.565.89L10 12.6q.071-.36.307-.766.247-.417.625-.7.39-.293.884-.293"
    />
  </svg>
);
export const InfoLineIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
